
const ImportPricingModalPluginSettings: IPluginSettings = {
    name: 'Импрот цунообразования',
    mnemocode: 'pricing_model_plugin',
    columns: []
}

export default ImportPricingModalPluginSettings
